
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype1Off as ObiMosfetNtype1OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-1-off.js';
 
 
 

 
 export const ObiMosfetNtype1Off = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-1-off',
   elementClass: ObiMosfetNtype1OffElement,
   events: {
     
   }
  });
 
 